webpackJsonp([1],{

/***/ "+0Mz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("D3zN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("oNjm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_header_html__ = __webpack_require__("rvop");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_header_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_header_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_footer_html__ = __webpack_require__("/Mwj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_footer_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_footer_html__);






var template = __WEBPACK_IMPORTED_MODULE_2__partials_header_html___default.a + __WEBPACK_IMPORTED_MODULE_1__index_html___default.a + __WEBPACK_IMPORTED_MODULE_3__partials_footer_html___default.a;
var source = 'https://www.youtube.com/embed/62GUa_XUosE?modestbranding=1&showinfo=1&rel=0';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].extend({

  name: 'VideoModal',

  template: template,

  data: function data() {
    return {
      showCloseBtn: false,
      classModifier: 'modal--stretch modal--bg-black'
    };
  },

  methods: {
    onHide: function onHide() {
      this.$refs.youtubeIframe.src = '';
    },
    onShow: function onShow() {
      this.$refs.youtubeIframe.src = source + '&autoplay=1';
    }
  }
}));

/***/ }),

/***/ "/Mwj":
/***/ (function(module, exports) {

module.exports = "<button class=\"modal__close-button icon-cross icon icon--action icon--round\" v-on:click=\"hide\" v-if=\"showCloseBtn\"></button>\n</div>\n</div>\n</div>\n</div>";

/***/ }),

/***/ "0+SN":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-align-middle\">\n  <div class=\"gr-7 gr-12@phablet\">\n    <p>A presskit including detailed information and high resolution images is now available for download.</a>\n    </p>\n  </div>\n  <div class=\"gr-5 gr-12@phablet flash-message__content__button-wrapper\">\n    <a class=\"button button--green button--rounded\" href=\"/static/downloads/e-Crown.zip\">\n          DOWNLOAD PRESSKIT\n        </a>\n  </div>\n</div>";

/***/ }),

/***/ "0FhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_bus__ = __webpack_require__("Dyy5");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'Hero',
  data: function data() {
    return {
      sihh: false,
      press: false
    };
  },


  methods: {
    openVideoModal: function openVideoModal() {
      __WEBPACK_IMPORTED_MODULE_2__plugins_bus__["a" /* default */].$emit('openModal', 'VideoModal');
    },
    onArrowClick: function onArrowClick() {
      __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a.scrollTo('.innovations');
    }
  },

  mounted: function mounted() {
    var url = window.location.href;

    if (url.indexOf('sihh') !== -1) {
      this.sihh = true;
    }

    if (url.indexOf('embargo') !== -1) {
      this.press = true;
    }

    __WEBPACK_IMPORTED_MODULE_2__plugins_bus__["a" /* default */].$on('arrow-clicked', this.onArrowClick);
  }
}));

/***/ }),

/***/ "0exw":
/***/ (function(module, exports) {

module.exports = "<div class=\"tabs__content\" v-bind:class=\"activeClass\">\n  <slot></slot>\n</div>\n";

/***/ }),

/***/ "0gMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrow__ = __webpack_require__("2KHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bg_video_index__ = __webpack_require__("uwgi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_calender_index__ = __webpack_require__("YfF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__counter_index__ = __webpack_require__("kfyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flash_messages_index__ = __webpack_require__("sVjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hero_index__ = __webpack_require__("0FhL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innovation_index__ = __webpack_require__("BdcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modals_index__ = __webpack_require__("D3zN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flash_messages_presskit_index__ = __webpack_require__("3Mnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flash_messages_sihh_index__ = __webpack_require__("2Tdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__phase_wrapper_index__ = __webpack_require__("BI8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tabs_tabs_index__ = __webpack_require__("enKQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tabs_tab_button_index__ = __webpack_require__("fQyX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tabs_tab_content_index__ = __webpack_require__("M2tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modals_video_index__ = __webpack_require__("+0Mz");
















/* harmony default export */ __webpack_exports__["a"] = ({
  XArrow: __WEBPACK_IMPORTED_MODULE_0__arrow__["a" /* default */],
  XBgVideo: __WEBPACK_IMPORTED_MODULE_1__bg_video_index__["a" /* default */],
  XCalenderModal: __WEBPACK_IMPORTED_MODULE_2__modals_calender_index__["a" /* default */],
  XCounter: __WEBPACK_IMPORTED_MODULE_3__counter_index__["a" /* default */],
  XFlashMessage: __WEBPACK_IMPORTED_MODULE_4__flash_messages_index__["a" /* default */],
  XHero: __WEBPACK_IMPORTED_MODULE_5__hero_index__["a" /* default */],
  XInnovation: __WEBPACK_IMPORTED_MODULE_6__innovation_index__["a" /* default */],
  XModal: __WEBPACK_IMPORTED_MODULE_7__modals_index__["a" /* default */],
  XPresskitFlashMessage: __WEBPACK_IMPORTED_MODULE_8__flash_messages_presskit_index__["a" /* default */],
  XSihhFlashMessage: __WEBPACK_IMPORTED_MODULE_9__flash_messages_sihh_index__["a" /* default */],
  XPhaseWrapper: __WEBPACK_IMPORTED_MODULE_10__phase_wrapper_index__["a" /* default */],
  XTabs: __WEBPACK_IMPORTED_MODULE_11__tabs_tabs_index__["a" /* default */],
  XTabButton: __WEBPACK_IMPORTED_MODULE_12__tabs_tab_button_index__["a" /* default */],
  XTabContent: __WEBPACK_IMPORTED_MODULE_13__tabs_tab_content_index__["a" /* default */],
  XVideoModal: __WEBPACK_IMPORTED_MODULE_14__modals_video_index__["a" /* default */]
});

/***/ }),

/***/ "2KHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_bus__ = __webpack_require__("Dyy5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_html__ = __webpack_require__("Oodw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_html__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'Arrow',
  template: __WEBPACK_IMPORTED_MODULE_2__index_html___default.a,
  methods: {
    onClick: function onClick() {
      __WEBPACK_IMPORTED_MODULE_1__plugins_bus__["a" /* default */].$emit('arrow-clicked');
    }
  }
}));

/***/ }),

/***/ "2Tdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("sVjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_bus__ = __webpack_require__("Dyy5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_html__ = __webpack_require__("z05q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_header_html__ = __webpack_require__("Ppz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_header_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_header_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_footer_html__ = __webpack_require__("fSfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_footer_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_footer_html__);







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].extend({
  name: 'SihhFlashMessage',
  template: __WEBPACK_IMPORTED_MODULE_3__partials_header_html___default.a + __WEBPACK_IMPORTED_MODULE_2__index_html___default.a + __WEBPACK_IMPORTED_MODULE_4__partials_footer_html___default.a,
  methods: {
    openCalenderModal: function openCalenderModal() {
      __WEBPACK_IMPORTED_MODULE_1__plugins_bus__["a" /* default */].$emit('openModal', 'CalenderModal');
    }
  }
}));

/***/ }),

/***/ "3Mnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("sVjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("0+SN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_header_html__ = __webpack_require__("Ppz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_header_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_header_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_footer_html__ = __webpack_require__("fSfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_footer_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_footer_html__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].extend({
  name: 'PresskitFlashMessage',
  template: __WEBPACK_IMPORTED_MODULE_2__partials_header_html___default.a + __WEBPACK_IMPORTED_MODULE_1__index_html___default.a + __WEBPACK_IMPORTED_MODULE_3__partials_footer_html___default.a
}));

/***/ }),

/***/ "8S7V":
/***/ (function(module, exports) {

module.exports = "<div class=\"bg-video\">\n  <div class=\"bg-video__content\">\n    <video class=\"bg-video__video\" muted loop autoplay v-bind:style=\"style\">\n      <source src=\"/static/videos/e-crown_1.mp4\" type=\"video/mp4\">\n    </video>\n  </div>\n</div>";

/***/ }),

/***/ "BI8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_phase__ = __webpack_require__("j0cL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_html__ = __webpack_require__("D8Ro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_html__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'PhaseWrapper',
  props: ['phase'],
  template: __WEBPACK_IMPORTED_MODULE_2__index_html___default.a,

  data: function data() {
    return {
      isActive: false
    };
  },


  methods: {
    getCurrentPhase: function getCurrentPhase() {
      var currentPhase = Object(__WEBPACK_IMPORTED_MODULE_1__utils_phase__["a" /* default */])();
      var phases = this.phase.split(',');

      this.isActive = phases.includes(currentPhase);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.getCurrentPhase();

    window.setInterval(function () {
      _this.getCurrentPhase();
    }, 1000);
  }
}));

/***/ }),

/***/ "BdcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("EmN+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'Innovation',
  template: __WEBPACK_IMPORTED_MODULE_1__index_html___default.a,
  props: ['image', 'type', 'title', 'url', 'size', 'color', 'bgColor', 'fallbackImage', 'secondImage'],

  data: function data() {
    var img = this.type === 'img-left' || this.type === 'img-right' || this.type === 'bg-img' || this.type === 'double-img' || this.type === 'center-img' ? __webpack_require__("lCRX")("./" + this.image) : null; // eslint-disable-line
    var fallbackImg = this.type === 'bg-img' ? __webpack_require__("lCRX")("./" + this.fallbackImage) : null; // eslint-disable-line
    var secondImg = this.type === 'double-img' ? __webpack_require__("lCRX")("./" + this.secondImage) : null; // eslint-disable-line
    return {
      img: img,
      fallbackImg: fallbackImg,
      secondImg: secondImg
    };
  },


  computed: {
    classes: function classes() {
      var classes = 'clearfix innovation ';

      switch (this.type) {
        case 'img-left':
        case 'img-right':
          classes += 'innovation--text-img';
          break;
        case 'bg-img':
          classes += 'innovation--bg-img';
          break;
        case 'text':
          classes += 'innovation--text';
          classes += ' innovation--text--' + this.color;
          break;
        case 'title':
          classes += 'innovation--title innovation--title--' + this.color;
          break;
        case 'double-img':
          classes += 'innovation--double-img ';
          break;
        case 'center-img':
          classes += 'innovation--center-img ';
          break;
        default:
          break;
      }

      if (this.size) classes += ' innovation--' + this.size;
      if (this.bgColor) classes += ' innovation--bg-' + this.bgColor;

      return classes;
    }
  }
}));

/***/ }),

/***/ "BoK7":
/***/ (function(module, exports) {

module.exports = "<div class=\"tabs\">\n  <slot></slot>\n</div>\n";

/***/ }),

/***/ "CPUW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  //eslint-disable-line
  return parseFloat(Math.round(value * Math.pow(10, n)) / Math.pow(10, n)).toFixed(n); //eslint-disable-line
});

/***/ }),

/***/ "D3zN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_bus__ = __webpack_require__("Dyy5");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return {
      isVisible: false,
      classModifier: ''
    };
  },


  methods: {
    hide: function hide() {
      this.isVisible = false;
      this.onHide();
    },
    onHide: function onHide() {},
    show: function show() {
      this.onShow();
      this.isVisible = true;
    },
    onShow: function onShow() {},
    onReceiveOpen: function onReceiveOpen(name) {
      if (this.$options.name === name) {
        this.show();
      }
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__plugins_bus__["a" /* default */].$on('openModal', this.onReceiveOpen);
  }
}));

/***/ }),

/***/ "D8Ro":
/***/ (function(module, exports) {

module.exports = "<div v-if=\"isActive\">\n  <slot></slot>\n</div>";

/***/ }),

/***/ "Doyw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Dyy5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (bus); // eslint-disable-line

/***/ }),

/***/ "EmN+":
/***/ (function(module, exports) {

module.exports = "<div v-bind:class=\"classes\">\n  <div class=\"innovation__wrapper\" v-if=\"type === 'img-left' || type === 'img-right'\">\n    <div class=\"gr-6 gr-12@phablet order-2@phablet innovation__container innovation__container--img-hidden\">\n      <div class=\"innovation__img\" :style=\"{ backgroundImage: 'url(\\'' + img + '\\')' }\"></div>\n    </div>\n\n    <div class=\"gr-6 gr-12@phablet order-2@phablet innovation__container innovation__container--img-shown\" v-if=\"type === 'img-left'\">\n      <div class=\"innovation__img\" :style=\"{ backgroundImage: 'url(\\'' + img + '\\')' }\"></div>\n    </div>\n\n    <div class=\"gr-6 gr-12@phablet innovation__container\">\n      <div class=\"innovation__block\">\n        <div class=\"innovation__block__wrapper\">\n          <span class=\"innovation__icon icon-triangle-down\"></span>\n\n          <h3 class=\"innovation__title\">\n          {{title}}\n          </h3>\n\n          <div class=\"innovation__description\">\n            <slot name=\"description\">\n            </slot>\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n    <div class=\"gr-6 gr-12@phablet innovation__container innovation__container--img-shown\" v-if=\"type === 'img-right'\">\n      <div class=\"innovation__img\" :style=\"{ backgroundImage: 'url(\\'' + img + '\\')' }\"></div>\n    </div>\n  </div>\n\n  <div v-if=\"type === 'text'\">\n    <div class=\"gr-12 innovation__container\">\n      <div class=\"innovation__block\">\n        <div class=\"innovation__block__wrapper\">\n          <span class=\"innovation__icon icon-triangle-down\" v-if=\"title\"></span>\n\n          <h3 class=\"innovation__title\" v-if=\"title\">\n          {{title}}\n          </h3>\n\n          <div class=\"innovation__description\">\n            <slot name=\"description\">\n            </slot>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div v-if=\"type === 'title'\">\n    <div class=\"gr-12 innovation__container\">\n      <div class=\"innovation__block\">\n        <div class=\"innovation__block__wrapper\">\n          <h1 class=\"innovation__title\">\n          {{title}}\n          </h1>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"clearfix innovation__wrapper\" v-if=\"type === 'bg-img'\" :style=\"{ backgroundImage: 'url(\\'' + img + '\\')' }\">\n    <div class=\"gr-6 gr-12@phablet order-2@phablet innovation__container innovation__container--img-hidden\">\n      <div class=\"innovation__img\" :style=\"{ backgroundImage: 'url(\\'' + fallbackImg + '\\')' }\"></div>\n    </div>\n    <div class=\"gr-6 gr-12@phablet innovation__container\">\n      <div class=\"innovation__block\">\n        <div class=\"innovation__block__wrapper\">\n          <span class=\"innovation__icon icon-triangle-down\"></span>\n\n          <h3 class=\"innovation__title\">\n          {{title}}\n          </h3>\n\n          <div class=\"innovation__description\">\n            <slot name=\"description\">\n            </slot>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"innovation__wrapper\" v-if=\"type === 'center-img'\" :style=\"{ backgroundImage: 'url(\\'' + img + '\\')' }\"></div>\n\n  <div class=\"innovation__wrapper\" v-if=\"type === 'double-img'\">\n    <div class=\"gr-6 gr-12@phablet order-2@phablet innovation__container\">\n      <div class=\"innovation__img\" :style=\"{ backgroundImage: 'url(\\'' + img + '\\')' }\"></div>\n    </div>\n\n    <div class=\"gr-6 gr-12@phablet order-2@phablet innovation__container\">\n      <div class=\"innovation__img\" :style=\"{ backgroundImage: 'url(\\'' + secondImg + '\\')' }\"></div>\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ "GKNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_modernizr_custom__ = __webpack_require__("pZLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__("cbRa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("0gMi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__("rsfq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_entry_scss__ = __webpack_require__("af4a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_entry_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scss_entry_scss__);







// CSS


/**
 * filters
 */
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */]).forEach(function (key) {
  var value = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */][key];

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(key, value);
});

/**
 * components
 */
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* default */]).forEach(function (key) {
  var value = __WEBPACK_IMPORTED_MODULE_4__components__["a" /* default */][key];

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component(key, value);
});

window.app = new __WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */]({
  el: '#v-app'
});

/***/ }),

/***/ "LY/X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/self-learning.371d59c.png";

/***/ }),

/***/ "M2tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("0exw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({

  name: 'TabContent',
  template: __WEBPACK_IMPORTED_MODULE_1__index_html___default.a,
  props: {
    name: {
      required: true
    }
  },

  computed: {
    activeClass: function activeClass() {
      if (this.$parent.activeTab === this.name) {
        return 'tabs__content--active';
      }

      return '';
    }
  }
}));

/***/ }),

/***/ "N3hL":
/***/ (function(module, exports) {

module.exports = "<div class=\"counter\">\n  <div class=\"row\">\n    <div class=\"counter__block\">\n      <p class=\"counter__block__digit\">{{ days}}</p>\n      <p class=\"counter__block__text\" v-if=\"days >= 0\">{{days > 1 || days == 0 ? 'days' : 'day'}}</p>\n      <p class=\"counter__block__text\" v-if=\"days < 0\">{{days !== 1 ? 'days' : 'day'}}</p>\n    </div>\n    <div class=\"counter__block\">\n      <p class=\"counter__block__digit\">{{ hours}}</p>\n      <p class=\"counter__block__text\" v-if=\"hours >= 0\">{{hours > 1 || hours == 0 ? 'hours' : 'hour'}}</p>\n      <p class=\"counter__block__text\" v-if=\"hours < 0\">{{hours !== 1 ? 'hours' : 'hour'}}</p>\n    </div>\n    <div class=\"counter__block\">\n      <p class=\"counter__block__digit\">{{ minutes}}</p>\n      <p class=\"counter__block__text\" v-if=\"minutes >= 0\">{{minutes || minutes == 0 > 1 ? 'minutes' : 'minute'}}</p>\n      <p class=\"counter__block__text\" v-if=\"minutes < 0\">{{minutes !== 1 ? 'minutes' : 'minute'}}</p>\n    </div>\n    <div class=\"counter__block counter__block--break\">\n      <p class=\"counter__block__digit\">{{ seconds}}</p>\n      <p class=\"counter__block__text\">\n        {{seconds !== 1 ? 'seconds' : 'second'}}</p>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"counter__timeline\" v-bind:style=\"{ width: timelineWidth + '%' }\"></div>\n  </div>\n</div>";

/***/ }),

/***/ "OCx6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/innovation.abb11bb.png";

/***/ }),

/***/ "Oodw":
/***/ (function(module, exports) {

module.exports = "<span class=\"arrow icon-arrow-down\" v-on:click=\"onClick\"></span>";

/***/ }),

/***/ "Ppz/":
/***/ (function(module, exports) {

module.exports = "<div class=\"flash-message\" v-bind:class=\"[!isVisible ? 'flash-message--hidden' : '']\">\n  <span class=\"flash-message__close-btn icon-cross icon--action\" v-on:click=\"hide\"></span>\n  <div class=\"flash-message__content\">\n";

/***/ }),

/***/ "QIKX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/self-sufficient.d13f6b9.png";

/***/ }),

/***/ "QYaT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/electro.f740cbb.png";

/***/ }),

/***/ "Qz16":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/self-sufficient-2.d13f6b9.png";

/***/ }),

/***/ "TT5+":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal__body\">\n  <div class=\"modal__section\">\n    <div class=\"offset-block\">\n      <x-tabs name=\"appointment\">\n        <div class=\"tabs__header\">\n          <div class=\"tabs__header__button-wrapper\">\n            <x-tab-button name=\"event-room-1\" label=\"event room 1\"></x-tab-button>\n            <x-tab-button name=\"event-room-2\" label=\"event room 2\"></x-tab-button>\n          </div>\n        </div>\n        <x-tab-content name=\"event-room-1\">\n          <div class=\"calender calendly-inline-widget\" data-url=\"https://calendly.com/tiziano-bagaar/ressence\"></div>\n        </x-tab-content>\n        <x-tab-content name=\"event-room-2\">\n          <div class=\"calender calendly-inline-widget\" data-url=\"https://calendly.com/tiziano-bagaar/ressence\"></div>\n        </x-tab-content>\n      </x-tabs>\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ "V8fz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nerve.9dc2217.png";

/***/ }),

/***/ "VrtV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/multi-functional.74f9eb5.png";

/***/ }),

/***/ "Vx1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_number_to_words__ = __webpack_require__("41+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_number_to_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_number_to_words__);


/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  //eslint-disable-line
  var digit = __WEBPACK_IMPORTED_MODULE_0_number_to_words___default.a.toWords(value);
  digit = digit.replace('-', ' ');
  return digit;
});

/***/ }),

/***/ "Wf8Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crown-to-e-crown.b219729.png";

/***/ }),

/***/ "YfF+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("D3zN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("TT5+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_header_html__ = __webpack_require__("rvop");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_header_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_header_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_footer_html__ = __webpack_require__("/Mwj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_footer_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_footer_html__);






var template = __WEBPACK_IMPORTED_MODULE_2__partials_header_html___default.a + __WEBPACK_IMPORTED_MODULE_1__index_html___default.a + __WEBPACK_IMPORTED_MODULE_3__partials_footer_html___default.a;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].extend({

  name: 'CalenderModal',

  template: template,

  data: function data() {
    return {
      showCloseBtn: true
    };
  }
}));

/***/ }),

/***/ "Zxxc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/self-setting.5d2cec7.png";

/***/ }),

/***/ "af4a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cbRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'App'
}));

/***/ }),

/***/ "e6dz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/self-regulating.546e7b9.png";

/***/ }),

/***/ "enKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("BoK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({

  name: 'Tabs',

  template: __WEBPACK_IMPORTED_MODULE_1__index_html___default.a,

  props: {
    name: {
      required: true
    }
  },

  data: function data() {
    return {
      activeTab: null,
      tabButtons: []
    };
  },


  methods: {
    defineChildren: function defineChildren() {
      this.defineTabButtons();
    },
    defineTabButtons: function defineTabButtons() {
      var _this = this;

      this.$children.forEach(function (btn) {
        var name = btn.$options.name;

        if (name === 'TabButton') {
          _this.tabButtons.push(btn);
        }
      });

      this.activeTab = this.tabButtons[0].name;
    },
    setActiveTab: function setActiveTab(tab) {
      this.activeTab = tab;
    }
  },

  mounted: function mounted() {
    this.defineChildren();
  }
}));

/***/ }),

/***/ "fQyX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("it7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({

  name: 'TabButton',
  template: __WEBPACK_IMPORTED_MODULE_1__index_html___default.a,

  props: {
    name: {
      required: true
    },
    label: {
      required: true
    }
  },

  computed: {
    activeClass: function activeClass() {
      var className = '';

      if (this.$parent.activeTab === this.name) {
        className = 'tabs__button--active';
      }

      return className;
    }
  },

  methods: {
    onTabClick: function onTabClick() {
      this.$parent.setActiveTab(this.name);
    }
  },

  ready: function ready() {
    this.compileElement();
  }
}));

/***/ }),

/***/ "fSfp":
/***/ (function(module, exports) {

module.exports = "</div>\n</div>\n";

/***/ }),

/***/ "hgv+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "it7H":
/***/ (function(module, exports) {

module.exports = "<div class=\"tabs__button\" v-bind:class=\"activeClass\" v-on:click=\"onTabClick\">\n  <p class=\"tabs__button__label\">{{label}}</p>\n</div>\n";

/***/ }),

/***/ "j0cL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_settings__ = __webpack_require__("noTV");



/* harmony default export */ __webpack_exports__["a"] = (function (phase) {
  //eslint-disable-line
  var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  var phases = __WEBPACK_IMPORTED_MODULE_1__config_settings__["a" /* default */].phases;
  var phase1Date = phases.phase1Date,
      phase2Date = phases.phase2Date;

  var currentPhase = null;

  if (now.isBefore(phase1Date)) {
    currentPhase = 'phase-0';
  } else if (now.isSameOrAfter(phase1Date) && now.isSameOrBefore(phase2Date)) {
    currentPhase = 'phase-1';
  } else if (now.isSameOrAfter(phase2Date)) {
    currentPhase = 'phase-2';
  }

  if (phase) return phase === currentPhase;
  return currentPhase;
});

/***/ }),

/***/ "kfyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_settings__ = __webpack_require__("noTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__("rsfq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_html__ = __webpack_require__("N3hL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_html__);







var phase2Date = __WEBPACK_IMPORTED_MODULE_3__config_settings__["a" /* default */].phases.phase2Date;

var calculateDifference = function calculateDifference() {
  var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
  var duration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(phase2Date.diff(now));
  var seconds = duration.asSeconds();

  return seconds;
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].extend({
  name: 'Counter',
  template: __WEBPACK_IMPORTED_MODULE_5__index_html___default.a,
  computed: {
    seconds: function seconds() {
      return __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].digits(this.secondsDiff % 60);
    },
    minutes: function minutes() {
      return __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].digits(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.secondsDiff / 60) % 60);
    },
    hours: function hours() {
      return __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].digits(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.secondsDiff / 60 / 60) % 24);
    },
    days: function days() {
      return __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].digits(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.secondsDiff / 60 / 60 / 24));
    },
    timelineWidth: function timelineWidth() {
      var seconds = this.secondsDiff % 60;
      return __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].digits(seconds / 60 * 100);
    }
  },
  data: function data() {
    return {
      secondsDiff: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.setInterval(function () {
      _this.secondsDiff = calculateDifference();
    }, 1000);
  }
}));

/***/ }),

/***/ "lCRX":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./crown-to-e-crown.png": "Wf8Y",
	"./electro.png": "QYaT",
	"./innovation.png": "OCx6",
	"./iphone.png": "o0da",
	"./multi-functional.png": "VrtV",
	"./nerve.png": "V8fz",
	"./self-learning.png": "LY/X",
	"./self-regulating.png": "e6dz",
	"./self-setting.png": "Zxxc",
	"./self-sufficient-1.png": "oa+D",
	"./self-sufficient-2.png": "Qz16",
	"./self-sufficient.png": "QIKX",
	"./touch.png": "ldPr",
	"./type-2-logo.png": "Doyw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lCRX";

/***/ }),

/***/ "ldPr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/touch.5c82b06.png";

/***/ }),

/***/ "noTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  phases: {
    phase1Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()('2017-12-28 16:00:00'),
    phase2Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()('2018-01-11 15:00:00')
  }
});

/***/ }),

/***/ "o0da":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone.5f8e5fa.png";

/***/ }),

/***/ "oNjm":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal__body\">\n  <div class=\"modal__section\">\n    <iframe ref=\"youtubeIframe\" width=\"100%\" height=\"100%\" src=\"\" frameborder=\"0\" allowfullscreen></iframe>\n  </div>\n</div>";

/***/ }),

/***/ "oa+D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/self-sufficient-1.1a3fe88.png";

/***/ }),

/***/ "pZLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*! modernizr 3.4.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function (e, n, t) {
  function o(e, n) {
    return (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) === n;
  }function s() {
    var e, n, t, s, a, i, r;for (var l in c) {
      if (c.hasOwnProperty(l)) {
        if (e = [], n = c[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
          e.push(n.options.aliases[t].toLowerCase());
        }for (s = o(n.fn, "function") ? n.fn() : n.fn, a = 0; a < e.length; a++) {
          i = e[a], r = i.split("."), 1 === r.length ? Modernizr[r[0]] = s : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = s), f.push((s ? "" : "no-") + r.join("-"));
        }
      }
    }
  }function a(e) {
    var n = u.className,
        t = Modernizr._config.classPrefix || "";if (p && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var o = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");n = n.replace(o, "$1" + t + "js$2");
    }Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), p ? u.className.baseVal = n : u.className = n);
  }function i() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : p ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }function r() {
    var e = n.body;return e || (e = i(p ? "svg" : "body"), e.fake = !0), e;
  }function l(e, t, o, s) {
    var a,
        l,
        f,
        c,
        d = "modernizr",
        p = i("div"),
        h = r();if (parseInt(o, 10)) for (; o--;) {
      f = i("div"), f.id = s ? s[o] : d + (o + 1), p.appendChild(f);
    }return a = i("style"), a.type = "text/css", a.id = "s" + d, (h.fake ? h : p).appendChild(a), h.appendChild(p), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(n.createTextNode(e)), p.id = d, h.fake && (h.style.background = "", h.style.overflow = "hidden", c = u.style.overflow, u.style.overflow = "hidden", u.appendChild(h)), l = t(p, e), h.fake ? (h.parentNode.removeChild(h), u.style.overflow = c, u.offsetHeight) : p.parentNode.removeChild(p), !!l;
  }var f = [],
      c = [],
      d = { _version: "3.4.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {
      var t = this;setTimeout(function () {
        n(t[e]);
      }, 0);
    }, addTest: function addTest(e, n, t) {
      c.push({ name: e, fn: n, options: t });
    }, addAsyncTest: function addAsyncTest(e) {
      c.push({ name: null, fn: e });
    } },
      Modernizr = function Modernizr() {};Modernizr.prototype = d, Modernizr = new Modernizr();var u = n.documentElement,
      p = "svg" === u.nodeName.toLowerCase(),
      h = d._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];d._prefixes = h;var m = d.testStyles = l;Modernizr.addTest("touchevents", function () {
    var t;if ("ontouchstart" in e || e.DocumentTouch && n instanceof DocumentTouch) t = !0;else {
      var o = ["@media (", h.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");m(o, function (e) {
        t = 9 === e.offsetTop;
      });
    }return t;
  }), s(), a(f), delete d.addTest, delete d.addAsyncTest;for (var v = 0; v < Modernizr._q.length; v++) {
    Modernizr._q[v]();
  }e.Modernizr = Modernizr;
}(window, document);

/***/ }),

/***/ "rsfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__digits__ = __webpack_require__("CPUW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__written_digits__ = __webpack_require__("Vx1e");



/* harmony default export */ __webpack_exports__["a"] = ({
  digits: __WEBPACK_IMPORTED_MODULE_0__digits__["a" /* default */],
  writtenDigits: __WEBPACK_IMPORTED_MODULE_1__written_digits__["a" /* default */]
});

/***/ }),

/***/ "rvop":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal\" v-bind:class=\"classModifier\" v-show=\"isVisible\" v-on:click=\"hide\">\n  <div class=\"modal__align\">\n    <div class=\"modal__cell\">\n      <div class=\"modal__box\" v-on:click.stop>";

/***/ }),

/***/ "sVjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'FlashMessage',

  data: function data() {
    return {
      isVisible: true
    };
  },


  methods: {
    hide: function hide() {
      this.isVisible = false;
    },
    show: function show() {
      this.isVisible = true;
    }
  }
}));

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uwgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html__ = __webpack_require__("8S7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_html__);



// todo update to final video when done
var videoWidth = 1920;
var videoHeight = 1080;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  name: 'BgVideo',
  template: __WEBPACK_IMPORTED_MODULE_1__index_html___default.a,
  data: function data() {
    return {
      style: {
        width: videoWidth,
        height: videoHeight,
        top: 0,
        left: 0
      }
    };
  },
  methods: {
    handleResize: function handleResize() {
      // resize the video to always fit in the parent
      var _$parent$$el = this.$parent.$el,
          clientHeight = _$parent$$el.clientHeight,
          clientWidth = _$parent$$el.clientWidth;


      var containerW = clientWidth;
      var containerH = clientHeight;
      var containerR = containerW / containerH;

      // get video size
      var videoW = parseInt(videoWidth, 10);
      var videoH = parseInt(videoHeight, 10);
      var videoR = videoW / videoH;

      // calculate proportions
      var vidW = 0;
      var vidH = 0;
      var vidT = 0;
      var vidL = 0;

      if (containerR > videoR) {
        // width = container with
        vidW = containerW;
        vidH = containerW / videoR;
        vidT = -Math.round((vidH - containerH) / 2);
        vidL = 0;
      } else {
        // height = containerheight
        vidW = containerH * videoR;
        vidH = containerH;
        vidT = 0;
        vidL = -Math.round((vidW - containerW) / 2);
      }

      this.style = {
        width: vidW + 'px',
        height: vidH + 'px',
        top: vidT + 'px',
        left: vidL + 'px'
      };
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);

    this.handleResize();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}));

/***/ }),

/***/ "z05q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"row-align-middle\">\n  <div class=\"gr-2 gr-12@phablet\">\n    <img class=\"flash-message__content__sihh-logo\" src=\"" + __webpack_require__("hgv+") + "\" />\n  </div>\n  <div class=\"gr-5 gr-12@phablet\">\n    <p>Book your personal appointment with Ressence during the SIHH event in Genève, and experience the revolution first hand.</p>\n  </div>\n  <div class=\"gr-5 gr-12@phablet flash-message__content__button-wrapper\">\n    <button class=\"button button--green button--rounded\" v-on:click=\"openCalenderModal\">\n          BOOK YOUR APPOINTMENT\n        </button>\n  </div>\n</div>\n";

/***/ })

},["GKNr"]);


// WEBPACK FOOTER //
// static/js/app.7a1c939af59ab31dc704.js